<template>
    <v-box element="div" v-if="excludeData.length > 0">
        <div class="v-histories">
            <h3 class="v-histories__title">Últimos visitados</h3>
            <div class="v-histories__items">
                <router-link
                    :key="inx"
                    :title="out.title"
                    :to="out.url"
                    class="v-histories__item"
                    v-for="(out, inx) in excludeData.slice(0, 6)"
                >
                    <div class="v-histories__image">
                        <img :alt="out.name" :src="url + out.image" />
                    </div>
                    <div class="v-histories__caption">
                        <h4>{{ out.name.length > 60 ? `${out.name.substring(0, 60)}...` : out.name }}</h4>
                        <p>{{ operationProp(out.country, out.operation) }}</p>
                        <span>
                            <b>Precio:</b>
                            {{ out.currency }} {{ out.price }}
                        </span>
                    </div>
                </router-link>
            </div>
        </div>
    </v-box>
</template>

<script>
import operationNames from '../helpers/operationNames'
import { mapGetters, mapState } from 'vuex'

export default {
    data() {
        return {
            url: 'https://images.mapaprop.app/photos/',
        }
    },
    computed: {
        ...mapGetters({
            historiesView: 'local/historiesView',
            path: 'path',
        }),
        excludeData() {
            const exclude = this.historiesView.filter((item) => item.url !== this.$route.path)
            return exclude
        },
    },
    methods: {
        operationProp(country, operation) {
            let result = ''

            operationNames[country].forEach((out, inx) => {
                if (out.value === operation) {
                    result = out.text
                }
            })

            return result
        },
    },
}
</script>

<style lang="scss">
.v-histories {
    &__title {
        padding: 1rem;
        font-weight: 600;
    }
    &__items {
    }
    &__item {
        padding: 0.5rem 1rem;
        display: flex;
        border-top: 1px solid #d3d3d3;
        &:hover {
            background-color: #f3f3f3;
        }
    }
    &__image {
        height: 100px;
        width: 140px;
        margin-right: 1rem;
        img {
            height: 100%;
            width: 100%;
            object-fit: cover;
        }
    }
    &__caption {
        width: calc(100% - (140px + 1rem));
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        h4 {
            font-size: 0.9rem;
        }
        p {
            font-size: 0.8rem;
        }
        span {
            b {
                font-weight: 600;
                color: #c9d700;
            }
        }
    }
    @media (max-width: 576px) {
        &__title {
            text-align: center;
        }
        &__item {
            padding: 0.5rem 1rem;
            display: block;
            &:hover {
                background-color: #f3f3f3;
            }
        }
        &__image {
            height: 120px;
            width: 200px;
            margin-left: auto;
            margin-right: auto;
            margin-bottom: 1rem;
            img {
                height: 100%;
                width: 100%;
                object-fit: cover;
            }
        }
        &__caption {
            width: 100%;
            h4 {
                margin-bottom: 1rem;
                text-align: center;
            }
            span {
                text-align: center;
            }
        }
    }
}
</style>
